import { isAfter } from 'date-fns';
import { Session } from '@graphql/gql/graphql';
/**
 * Filters sessions based on their end times.
 *
 * @param {Array} items - The array of sessions to be filtered.
 * @param {Number} now - The reference time to compare item end times against.
 * @returns {Array} - A new array containing sessions with end times after the reference time.
 */
const stripCurrentSessionOnEndTime = (items: Array<Session>, now: number): Array<Session> => {
  return items?.filter(item => isAfter(new Date(item.end), new Date(now)));
};

export default stripCurrentSessionOnEndTime;
